import { ConnectableObservable } from '../observable/ConnectableObservable';
import { hasLift, operate } from '../util/lift';
export function multicast(subjectOrSubjectFactory, selector) {
    const subjectFactory = typeof subjectOrSubjectFactory === 'function' ? subjectOrSubjectFactory : () => subjectOrSubjectFactory;
    if (typeof selector === 'function') {
        return operate((source, subscriber) => {
            const subject = subjectFactory();
            selector(subject).subscribe(subscriber).add(source.subscribe(subject));
        });
    }
    return (source) => {
        const connectable = new ConnectableObservable(source, subjectFactory);
        if (hasLift(source)) {
            connectable.lift = source.lift;
        }
        connectable.source = source;
        connectable.subjectFactory = subjectFactory;
        return connectable;
    };
}
//# sourceMappingURL=multicast.js.map